import { SA_BASE_PATH } from 'shared'

/**
 * Keeps the South Australia hosts to South Australian pages.
 *
 * Those hosts proxy straight to this app, so without this every national page would answer on
 * them too — the menu and footer would read as though the whole site lived at sa.waitmate.org.au.
 * A route middleware rather than an nginx rule because the links are `NuxtLink`s: a click is a
 * client-side route change that never reaches the server, and this runs on both sides.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!useIsSaHost()) return

  // The SA landing answers at `/` on these hosts (see app/pages/index.vue), the one SA page
  // that doesn't live under /sa.
  if (to.path === '/') return

  // Read off the router instead of a list kept in step by hand: the legacy SA URLs are
  // registered as aliases of the pages under app/pages/sa/, so a page added there is served
  // here at both its /sa path and any alias, without this file knowing about it.
  const matched = to.matched[0]
  const routePath = (matched?.aliasOf ?? matched)?.path

  if (routePath === SA_BASE_PATH || routePath?.startsWith(`${SA_BASE_PATH}/`)) {
    return
  }

  const siteUrl = useRuntimeConfig().public.siteUrl.replace(/\/+$/, '')

  // Nowhere to send them, and a site URL pointing back at this host would bounce forever.
  if (!siteUrl || new URL(siteUrl).hostname === useRequestURL().hostname) return

  // 302 rather than 301: the split between the two hosts is new, and a permanent redirect
  // would be cached out of our hands before we know it holds.
  return navigateTo(`${siteUrl}${to.fullPath}`, {
    external: true,
    redirectCode: 302,
  })
})
